// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4beb4a35","453":"f6936425","455":"3df02e12","977":"25d46333"}[chunkId] + ".chunk.js";
};